/* eslint-disable react/prop-types */
import React from 'react'

import { FormControl, Select, MenuItem } from '@mui/material'

class OptionsDropDown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      subOptions: [],
    }
  }

  componentDidMount() {
    const { positivityOption } = this.props
    this.setState({
      subOptions: positivityOption.options,
    })
  }

  getSavedValue = (title) => {
    const { savedDiagnosisData } = this.props
    return savedDiagnosisData[title]
      ? savedDiagnosisData[title]
      : savedDiagnosisData.slidePositiveReportText
      ? savedDiagnosisData.slidePositiveReportText
      : 'Select'
  }

  getValue = (title) => {
    const { currentStain, isPositive, savedDiagnosisData } = this.props
    return Object.keys(savedDiagnosisData).length
      ? savedDiagnosisData[title]
        ? savedDiagnosisData[title]
        : savedDiagnosisData.slidePositiveReportText
        ? savedDiagnosisData.slidePositiveReportText
        : 'Select'
      : 'Select'
  }

  render() {
    const { currentStain, handleSelectDropdown, isPositive, isReadOnlyMode, positivityOption, selectedOption } =
      this.props
    const { subOptions } = this.state
    return (
      <FormControl>
        <Select
          defaultValue={this.getSavedValue(positivityOption.title)}
          value={this.getValue(positivityOption.title)}
          onChange={(e) => handleSelectDropdown(positivityOption.title, e)}
          style={{ width: '200px', height: '40px', float: 'right' }}
          disabled={
            isReadOnlyMode
              ? true
              : isPositive === undefined ||
                isPositive === 'Positive' ||
                (isPositive === 'Negative' && currentStain.toLowerCase() === 'alcian blue')
              ? false
              : true
          }
        >
          <MenuItem value={'Select'} disabled={isReadOnlyMode}>
            {'Select'}
          </MenuItem>
          {subOptions.map((subOption, index) => {
            return (
              <MenuItem value={subOption} key={index}>
                {subOption}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    )
  }
}

export default OptionsDropDown
